import React, { useState } from "react";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="bg-gradient-to-r from-gray-700 to-gray-900 text-gray-100 shadow sticky top-0 py-4 z-50">
      <div className="container mx-auto flex justify-between items-center px-4 md:container md:mx-auto">
        <a href="/" className="text-xl font-bold" style={{ color: "rgb(92, 225, 230)" }}>AK</a>
        <nav className="md:hidden">
          <button
            className="focus:outline-none focus:text-gray-300"
            onClick={toggleMobileMenu}
          >
            {isMobileMenuOpen ? (
              <AiOutlineClose className="text-xl" />
            ) : (
              <AiOutlineMenu className="text-xl" />
            )}
          </button>
        </nav>
        <nav className="hidden md:block">
          <ul className="flex">
            <li className="ml-6">
              <a href="#hero" className="hover:text-gray-300">Home</a>
            </li>
            <li className="ml-6">
              <a href="#projects" className="hover:text-gray-300">Projects</a>
            </li>
            <li className="ml-6">
              <a href="#skills" className="hover:text-gray-300">Skills</a>
            </li>
            <li className="ml-6">
              <a href="#about" className="hover:text-gray-300">About</a>
            </li>
            <li className="ml-6">
              <a href="#contact" className="hover:text-gray-300">Contact</a>
            </li>
          </ul>
        </nav>
        {isMobileMenuOpen && (
          <nav className="md:hidden">
            <ul className="flex flex-col">
              <li className="mb-3">
                <a href="#hero" className="hover:text-gray-300">Home</a>
              </li>
              <li className="mb-3">
                <a href="#projects" className="hover:text-gray-300">Projects</a>
              </li>
              <li className="mb-3">
                <a href="#skills" className="hover:text-gray-300">Skills</a>
              </li>
              <li className="mb-3">
                <a href="#about" className="hover:text-gray-300">About</a>
              </li>
              <li className="mb-3">
                <a href="#contact" className="hover:text-gray-300">Contact</a>
              </li>
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;